'use client'
import React from 'react';
import styled from "styled-components";
import {hover, white} from "@/styles/globalStyleVars";
import SvgButton from "@/components/SvgButton";
import Link from "next/link";
import parser from "html-react-parser";

let svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="11.207" opacity="0.5" height="11.414"
                                                     viewBox="0 0 11.207 11.414">
                                                    <line id="Line_3858" data-name="Line 3858" x2="5" y2="5"
                                                          transform="translate(5.5 0.707)" fill="none" stroke="#FFFFFF"
                                                          stroke-linecap="round" stroke-width="1"/>
                                                    <line id="Line_3859" data-name="Line 3859" y1="5" x2="5"
                                                          transform="translate(5.5 5.707)" fill="none" stroke="#FFFFFF"
                                                          stroke-linecap="round" stroke-width="1"/>
                                                    <line id="Line_3860" data-name="Line 3860" x1="10"
                                                          transform="translate(0.5 5.707)" fill="none" stroke="#FFFFFF"
                                                          stroke-linecap="round" stroke-width="1"/>
                                                </svg>
    `;
const SingleService = ({icon,title,link, nolink}) => {


    return (
        <StyledComponent>
            {
                nolink ?
                    <div className="service__box__single">
                        <div className={'service__box__single__top'}>
                            <img src={icon} height={70} width={80} alt={title ? title : 'Services Icon'}/>
                            <SvgButton svg={svg}
                                       borderColor={white}
                                       width={30}
                                       height={30}
                                       background={white}
                            />
                        </div>
                        <h4 className={'split-up'}>{parser(title)}</h4>
                    </div>

                    :

                    <Link href={link}>
                        <div className="service__box__single">
                            <div className={'service__box__single__top'}>
                                <img src={icon} height={70} width={80} alt={title ? title : 'Services Icon'}/>
                                <SvgButton svg={svg}
                                           borderColor={white}
                                           width={30}
                                           height={30}
                                           background={white}
                                />
                            </div>
                            <h4 className={'split-up'}>{parser(title)}</h4>
                        </div>
                    </Link>
            }

        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    position: relative;
    height: 100%;

    .circle {
        top: -5px;
        right: -5px;
    }

    .service__box__single {
        position: relative; /* Ensure relative positioning */
        padding: 30px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        height: 120%;
        transition: transform 0.9s ease; /* Transition for rotation */

        svg {
            transform: rotate(-45deg);
            transition: transform 0.9s ease; /* Transition for rotation */
            z-index: 9999;
        }

        &:after {
            content: '';
            height: 0;
            width: 100%;
            background-color: ${hover} !important;
            bottom: 0;
            left: 0;
            right: 0;
            position: absolute;
            transition: height .4s ease;
        }

        &__top {
            margin-bottom: 50px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            img {
                z-index: 99;
            }

            svg {
                z-index: 999999;
            }
        }

        &:hover {
            border: 1px solid ${hover};

            .service__box__single__top {
                .hover {
                    z-index: 9999;

                    &:after {
                        z-index: 9999;

                        background-color: ${white} !important;
                        height: 110%;
                        width: 110%;
                    }
                }
            }

            svg {
                transform: rotate(0deg); /* Rotate to 0 degrees on hover */

                line {
                    stroke: ${hover} !important;
                }
            }

            &:after {
                height: 100%;
            }
        }
    }

    h4 {
        position: absolute;
        bottom: 30px;
        color: #FFFFFF;
        z-index: 99;
        font-weight: 500;
    }

    .circle {
        border: 1px solid rgba(255, 255, 255, 0.5);
    }

    @media (max-width: 767px) {
        .experience__box__single {
            padding: 30px 15px;
        }
    }
`;

export default React.memo(SingleService);
